import React, {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import {LoadingProvider, CurrentUserProvider} from 'usg-lib';
import {PostHogProvider} from 'posthog-js/react'
import {BrowserRouter} from "react-router-dom";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  person_profiles: 'identified_only',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  persistence: 'localStorage+cookie',
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <BrowserRouter basename="/">
        <LoadingProvider>
          <CurrentUserProvider>
            <App />
          </CurrentUserProvider>
        </LoadingProvider>
      </BrowserRouter>
    </PostHogProvider>
  </StrictMode>,
);
